import { useEffect } from 'react';

/**
 * Hook to detect clicks outside a referenced element
 * @param {React.RefObject} ref - Ref to the element to monitor
 * @param {Function} callback - Function to call when click outside is detected
 * @param {Object} options - Optional configuration
 * @param {number} options.delay - Delay before attaching listener (to avoid immediate triggers)
 */
export default function useClickOutside(ref, callback, options = {}) {
  const { delay = 0 } = options;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback?.(event);
      }
    };

    if (delay > 0) {
      const timer = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
      }, delay);
      return () => {
        clearTimeout(timer);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, callback, delay]);
}
